import { render } from "./NetsCardItem.vue?vue&type=template&id=2089f6f7&scoped=true"
import script from "./NetsCardItem.vue?vue&type=script&lang=js"
export * from "./NetsCardItem.vue?vue&type=script&lang=js"

import "./NetsCardItem.vue?vue&type=style&index=0&id=2089f6f7&scoped=true&lang=css"
import "./NetsCardItem.vue?vue&type=style&index=1&id=2089f6f7&lang=css"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2089f6f7"]])

export default __exports__